import React from "react";
import { motion } from "framer-motion";
import { useScrollReveal } from "../hooks/useScrollReveal";

const EASE = [0.22, 1, 0.36, 1];

/**
 * Wraps children with a one-shot scroll-triggered fade+rise animation.
 */
export default function Reveal({ as = "div", delay = 0, y = 24, className = "", children, ...rest }) {
  const [ref, visible] = useScrollReveal();
  const Tag = motion[as] || motion.div;

  return (
    <Tag
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={visible ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.7, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </Tag>
  );
}
